export default __webpack_public_path__ + "static/media/grid.809d231c.png";